import { app } from '../shared';

export const fetchGeo = async () => {
  return app.service('geos').find({});
};
